import type { AppRouteModule } from '@/router/types';

import { t } from '@/hooks/web/useI18n';
import goAppBase from '@/router/routes/modules/go-app-base';
import goAppOrg from '@/router/routes/modules/go-app-org';
import goAppFlow from '@/router/routes/modules/go-app-flow';
import goAppRocketShow from '@/router/routes/modules/go-app-rocket-show';
import emailRoutes from "@/views/innerEmailMg/router/emailRoutes";
import proPlanMain from "@/views/proPlanMain/router/routes";

const dashboard: AppRouteModule = {
  path: '/dashboard',
  name: 'Dashboard',
  redirect: '/dashboard/analysis',
  meta: {
    keepAlive: true,
    orderNo: 10,
    icon: 'ion:grid-outline',
    title: t('routes.dashboard.dashboard'),
  },
  children: [
    ...proPlanMain,
    ...emailRoutes,
    ...goAppFlow,
    ...goAppRocketShow,
    ...goAppBase,
    ...goAppOrg,
    {
      path: '/xm-erp/commonPage/:pageCode',
      name: 'commonPage',
      meta: {
        keepAlive: true,
        title: t('dynamicName'),
      },
      component: () => import(/* webpackChunkName: "commonPage" */ '@/views/userDefPage.vue')
    },
    {
      path: 'appMainPage',
      name: 'appMainPage',
      component: () =>
        import(
          /* webpackChunkName: "workbench" */ '@/layouts/layoutFrame/appFrame/AppMainPage.vue'
        ),
      meta: {
        keepAlive: true,
        // affix: true,
        title: t('主页'),
      },
    },
    {
      path: '/xmPortalMainPage/:portalId',
      name: 'xmPortalMainPage',
      component: () =>
        import(
          /* webpackChunkName: "workbench" */ '@/views/xmPortalMainPage/xmPortalMainPage.vue'
          ),
      meta: {
        // affix: true,
        keepAlive: true,
        title: t('dynamicName'),
      },
    },
    {
      path: '/vue3Des/showPage/:pageCode',
      name: 'vue3Des',
      component: () =>
        import(
          /* webpackChunkName: "workbench" */ '@/views/useDefPage/userDefPage.vue'
          ),
      meta: {
        // affix: true,
        title: t('dynamicName'),
      },
    },
    {
      path: '/xmShowPortal/:portalId',
      name: 'xmShowPortal',
      component: () =>
        import(
          /* webpackChunkName: "workbench" */ '@/layouts/layoutFrame/appFrame/XmShowPortal.vue'
        ),
      meta: {
        // affix: true,
        keepAlive: true,
        title: t('dynamicName'),
      },
    },
    {
      path: 'analysis',
      name: 'Analysis',
      component: () =>
        import(/* webpackChunkName: "workbench" */ '@/views/dashboard/analysis/index.vue'),
      meta: {
        affix: true,
        title: t('routes.dashboard.analysis'),
      },
    },
  ],
};

export default dashboard;
